import { render } from "./VODReachLimitBanner.vue?vue&type=template&id=edc7494a&scoped=true"
import script from "./VODReachLimitBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./VODReachLimitBanner.vue?vue&type=script&setup=true&lang=js"

import "./VODReachLimitBanner.vue?vue&type=style&index=0&id=edc7494a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc7494a"],['__file',"src/components/VOD/VODReachLimitBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "edc7494a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('edc7494a', __exports__)) {
    api.reload('edc7494a', __exports__)
  }
  
  module.hot.accept("./VODReachLimitBanner.vue?vue&type=template&id=edc7494a&scoped=true", () => {
    api.rerender('edc7494a', render)
  })

}


export default __exports__